import {ReactNode} from "react";
import {css, cva, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {SkeletonBox} from "@pg-mono/skeleton-box";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

interface Props {
    title: string;
    underTitleElement?: ReactNode;
    priceM2?: number | null;
    price?: number | null;
    description: string;
    source: string;
    sourceDetails?: ReactNode;
    variant: "white" | "beige";
    isLoading?: boolean;
    className?: string;
    /** Overrides the default "Brak danych" fallback - e.g. "Za mało transakcji" when the source has data, just not enough of it. */
    emptyStateMessage?: string;
}

export const PriceComparisonCard = (props: Props) => {
    const {title, underTitleElement, priceM2, price, description, source, sourceDetails, variant, isLoading, className, emptyStateMessage} = props;

    const formattedPrice = price && price > 0 ? priceFormat(price) : priceM2 && priceM2 > 0 ? priceM2Format(priceM2) : (emptyStateMessage ?? "Brak danych");

    return (
        <div className={cx(cardStyle({variant}), className)}>
            <Text variant="button_small" as="p" color="var(--colors-gray-700)">
                {title}
            </Text>

            {underTitleElement}

            {isLoading ? (
                <SkeletonBox isText height="4.8rem" width="18rem" />
            ) : (
                <Text variant="headline_0" as="p">
                    {formattedPrice}
                </Text>
            )}

            <Text variant="body_copy_1" color="var(--colors-gray-700)">
                {description}
            </Text>

            <div className={css({mt: "auto"})}>
                {sourceDetails}

                <Text variant="info_txt_1" color="var(--colors-gray-600)">
                    {source}
                </Text>
            </div>
        </div>
    );
};

const cardStyle = cva({
    base: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        p: 2,
        border: "1px solid var(--colors-gray-400)",
        borderRadius: 2,

        md: {
            gap: 1.5,
            p: 3.5,
            flex: "1 1 0"
        }
    },
    variants: {
        variant: {
            white: {backgroundColor: "var(--colors-white)"},
            beige: {backgroundColor: "var(--colors-beige-subtle)"}
        }
    }
});
import {ReactNode} from "react";
import {css, cva, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {SkeletonBox} from "@pg-mono/skeleton-box";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

interface Props {
    title: string;
    underTitleElement?: ReactNode;
    priceM2?: number | null;
    price?: number | null;
    description: string;
    source: string;
    sourceDetails?: ReactNode;
    variant: "white" | "beige";
    isLoading?: boolean;
    className?: string;
    /** Overrides the default "Brak danych" fallback - e.g. "Za mało transakcji" when the source has data, just not enough of it. */
    emptyStateMessage?: string;
}

export const PriceComparisonCard = (props: Props) => {
    const {title, underTitleElement, priceM2, price, description, source, sourceDetails, variant, isLoading, className, emptyStateMessage} = props;

    const formattedPrice = price && price > 0 ? priceFormat(price) : priceM2 && priceM2 > 0 ? priceM2Format(priceM2) : (emptyStateMessage ?? "Brak danych");

    return (
        <div className={cx(cardStyle({variant}), className)}>
            <Text variant="button_small" as="p" color="var(--colors-gray-700)">
                {title}
            </Text>

            {underTitleElement}

            {isLoading ? (
                <SkeletonBox isText height="4.8rem" width="18rem" />
            ) : (
                <Text variant="headline_0" as="p">
                    {formattedPrice}
                </Text>
            )}

            <Text variant="body_copy_1" color="var(--colors-gray-700)">
                {description}
            </Text>

            <div className={css({mt: "auto"})}>
                {sourceDetails}

                <Text variant="info_txt_1" color="var(--colors-gray-600)">
                    {source}
                </Text>
            </div>
        </div>
    );
};

const cardStyle = cva({
    base: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        p: 2,
        border: "1px solid var(--colors-gray-400)",
        borderRadius: 2,

        md: {
            gap: 1.5,
            p: 3.5,
            flex: "1 1 0"
        }
    },
    variants: {
        variant: {
            white: {backgroundColor: "var(--colors-white)"},
            beige: {backgroundColor: "var(--colors-beige-subtle)"}
        }
    }
});
